<template>
  <div class="card mb-4">
    <div class="card-header pb-0">
      <h6>进件资料表</h6>
    </div>
    <div class="card-body px-0 pt-0 pb-2">
      <div class="table-responsive p-0">
        <table class="table align-items-center mb-0">
          <thead>
            <tr>
              <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                商家ID[资料ID]
              </th>
              <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2">
                资料详情
              </th>
              <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                申请状态
              </th>
              <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                提交时间
              </th>
              <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                驳回理由
              </th>
              <th class="text-secondary opacity-7"></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(submission, index) in paginatedSubmissions" :key="submission.data_id">
              <td>
                <div class="d-flex px-2 py-1">
                  <div>
                    <soft-avatar
                      :img="submission.img || img1"
                      size="sm"
                      border-radius="lg"
                      class="me-3"
                      alt="user-avatar"
                    />
                  </div>
                  <div class="d-flex flex-column justify-content-center">
                    <h6 class="mb-0 text-sm">{{ submission.deliver_id }}[{{submission.info_id}}]</h6>
                    <p class="text-xs text-secondary mb-0" style="display:none">{{index}}</p>
                  </div>
                </div>
              </td>
              <td>
                <p class="text-xs font-weight-bold mb-0" @click="toggleDetails(submission)">点击查看详情</p>
              </td>
              <td class="align-middle text-center text-sm">
                <!-- 下拉框选择状态 -->
                <select v-model="submission.status" class="form-select" @change="handleStatusChange(submission)">
                  <option value="new">新提交</option>
                  <option value="declined">驳回</option>
                  <option value="approved">通过</option>
                  <option value="handling">处理中</option>
                </select>
              </td>
              <td class="align-middle text-center">
                <span class="text-secondary text-xs font-weight-bold">
                  {{ formatDate(submission.created_date) }}
                </span>
              </td>
              <td class="align-middle text-center">
                <span class="text-secondary text-xs font-weight-bold">
                  {{ submission.feedback || '无' }}
                </span>
              </td>
              <td class="align-middle">
                <a
                  href="javascript:;"
                  class="text-secondary font-weight-bold text-xs"
                  @click="toggleConfig(submission)"
                >配置通道</a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- 分页控制 -->
      <div class="d-flex justify-content-between mt-3">
        <button
          class="btn btn-sm btn-outline-primary"
          :disabled="currentPage === 1"
          @click="prevPage"
        >
          上一页
        </button>
        <span class="text-sm">第 {{ currentPage }} 页 / 共 {{ totalPages }} 页</span>
        <button
          class="btn btn-sm btn-outline-primary"
          :disabled="currentPage === totalPages"
          @click="nextPage"
        >
          下一页
        </button>
      </div>
    </div>
  </div>

  <!-- 使用 Vue modal 弹窗来显示 SubmissionDetails -->
  <div v-if="showDetails" class="modal-overlay">
    <div class="modal-content">
      <SubmissionDetails :submission="selectedSubmission" @close="closeDetails" />
    </div>
  </div>

  <!-- 使用 Vue modal 弹窗来显示 SubmissionDetails -->
  <div v-if="showConfig" class="modal-overlay">
    <div class="modal-content">
      <ChanelConfig :submission="selectedSubmission" @close="closeConfig" />
    </div>
  </div>
  <!-- 驳回原因的弹窗 -->
  <div v-if="showRejectPopup" class="modal-overlay">
    <div class="modal-content">
      <h3>请输入驳回原因</h3>
      <textarea v-model="rejectReason" rows="4" class="form-control"></textarea>
      <div class="mt-3">
        <button class="btn btn-danger" @click="confirmReject">确认驳回</button>
        <button class="btn btn-secondary" @click="closeRejectPopup">取消</button>
      </div>
    </div>
  </div>
</template>

<script>
import SoftAvatar from "@/components/SoftAvatar.vue";
//import SoftBadge from "@/components/SoftBadge.vue";
import SubmissionDetails from "./SubmissionDetails.vue"; // 引入 SubmissionDetails 组件
import ChanelConfig from "./ChanelConfig.vue"; // 引入 SubmissionDetails 组件
import img1 from "../../assets/img/file.jpeg";
import { getmerchpayinfos, declineMerchPayInfos } from "@/api/merch.js"; // 引入获取进件资料的 API 和驳回接口
import dayjs from "dayjs"; // 引入 dayjs 库处理时间

export default {
  name: "SubmissionTables",
  data() {
    return {
      img1,
      submissions: [], // 存储所有的进件数据
      showDetails: false, // 控制显示 SubmissionDetails
      showConfig: false, // 控制显示 ChanelConfig
      showRejectPopup: false, // 控制是否显示驳回原因弹窗
      selectedSubmission: null, // 选中的进件数据
      currentPage: 1, // 当前页码，默认为第一页
      pageSize: 8, // 每页显示的记录数
      paginatedSubmissions: [], // 当前页显示的数据
      totalPages: 1, // 总页数
      rejectReason: "", // 驳回原因
    };
  },
  components: {
    SoftAvatar,
    //SoftBadge,
    SubmissionDetails, // 注册 SubmissionDetails 组件
    ChanelConfig,
  },
  methods: {
    // 获取进件数据
    fetchSubmissions() {
      getmerchpayinfos().then(response => {
        if (response.code === 0) {
          //console.log("get submissions:", response.desc);
          // 假设返回的数据是一个数组
          this.submissions = response.desc.map(submission => ({
            ...submission,
            submit_time: dayjs(submission.created_date).format("YYYY/MM/DD HH:mm:ss"), // 格式化时间
          }));
          // 计算总页数
          this.totalPages = Math.ceil(this.submissions.length / this.pageSize);
          this.updatePaginatedData(); // 更新当前页的数据
        } else {
          alert("获取进件资料失败：" + response.desc);
        }
      }).catch(error => {
        console.error("获取进件数据时出错：", error);
        alert("获取进件资料失败，请稍后再试。");
      });
    },

    // 处理下拉框选择变化
    handleStatusChange(submission) {
      if (submission.status === 'declined') {
        this.selectedSubmission = submission; // 选择当前进件数据
        this.showRejectPopup = true; // 显示驳回原因弹窗
      }
    },

    // 确认驳回
    confirmReject() {
      if (!this.rejectReason) {
        alert("请输入驳回原因！");
        return;
      }

      // 调用 API 进行驳回操作
      declineMerchPayInfos({
        info_id: this.selectedSubmission.info_id,
        feedback: this.rejectReason,
      })
      .then(response => {
        if (response.code === 0) {
          alert("驳回成功！");
          this.showRejectPopup = false; // 关闭弹窗
          this.fetchSubmissions(); // 刷新列表数据
        } else {
          alert("驳回失败：" + response.desc);
        }
      })
      .catch(error => {
        console.error("驳回请求出错：", error);
        alert("驳回失败，请稍后再试。");
      });
    },

    // 关闭驳回原因弹窗
    closeRejectPopup() {
      this.showRejectPopup = false;
    },

    // 切换 SubmissionDetails 组件的显示状态，并传递当前行的数据
    toggleDetails(submission) {
      this.selectedSubmission = submission; // 选择当前进件数据
      this.showDetails = true; // 显示弹窗
    },

    toggleConfig(submission) {
      this.selectedSubmission = submission; // 选择当前进件数据
      this.showConfig = true; // 显示弹窗
    },

    // 关闭 SubmissionDetails
    closeConfig() {
      this.showConfig = false; // 关闭弹窗
    },

    closeDetails() {
      this.showDetails = false; // 关闭弹窗
    },

    // 格式化时间
    formatDate(timestamp) {     
      const newDate = dayjs(timestamp*1000).format("YYYY/MM/DD HH:mm:ss");
      //console.log("formating:", timestamp, "date:", newDate)
      return newDate
    },

    // 更新当前页显示的数据
    updatePaginatedData() {
      const startIndex = (this.currentPage - 1) * this.pageSize;
      const endIndex = this.currentPage * this.pageSize;
      this.paginatedSubmissions = this.submissions.slice(startIndex, endIndex);
    },

    // 下一页
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
        this.updatePaginatedData();
      }
    },

    // 上一页
    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
        this.updatePaginatedData();
      }
    },
  },

  mounted() {
    this.fetchSubmissions(); // 页面加载时获取进件数据
  },
};
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.modal-content {
  background: white;
  padding: 20px;
  border-radius: 5px;
  width: 60%;
  max-width: 600px;
}

.modal-content h2 {
  margin-top: 0;
}

button {
  margin-top: 10px;
}
</style>
